<section class="banner">
  <img [ngSrc]="bannerUrl" alt="banner" width="100" height="100" priority>
</section>
